import axios from "axios";
import React, {createContext, useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import Select, {createFilter} from "react-select";
import {useTable} from "react-table";
import "jspdf-autotable";
import {
    editAccountManagerApi,
    getAccountUserListApi,
    saveAccountManagerApi,
    validateAccountManagerExistsApi
} from "../Api";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";
import {useForm} from "react-hook-form";
import ConsoleHelper from "../ConsoleHelper";
import {DateFormatterWithAMPM} from "../Utils/DateFormatter";

export const accountListContext = createContext();
function AccountManagerProperties(props) {
    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()} ${current.getHours()}:${current.getMinutes()}:${current.getSeconds()}`;
    const [isEditable, setIsEditable] = useState(false);
    const [buttonText, setButtonText] = useState("Save");
    const [accountsData, setAccountsData] = useState();
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const [visibleToUserSelectData, setVisibleToUserSelectData] = useState([]);
    const [selectedVisibleToUser, setSelectedVisibleToUser] = useState();
    const [accountOwnerSelectData, setAccountOwnerelectData] = useState([]);
    const [selectedAccountOwner, setSelectedAccountOwner] = useState();
    const [country, setCountry] = useState();
    const [countryData, setCountryData] = useState();
    const [data, setData] = useState([]);
    const [rtaNumber, setRtaNumber] = useState();
    const [accountTransitNumber, setAccountTransitNumber] = useState();
    const [accountBankNumber, setAccountBankNumber] = useState();
    const [accountNumber, setAccountNumber] = useState();
    const [accountType, setAccountType] = useState();
    const [accountTypeData, setAccountTypeData] = useState([]);
    const [consolidationType, setConsolidationType] = useState();
    const [consolidationOptions, setConsolidationOptions] = useState();
    const [selectedConsolidationOrder, setConsolidationOrder] = useState();
    const [userOptions, setUserOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState();
    const [paramAccountID, setParamAccountID] = useState();
    const [approvalFlag, setApprovalFlag] = useState(0);
    const [createdBy, setCreatedBy] = useState(loggedUserStorage);
    const [currentStatus, setCurrentStatus] = useState();
    const [currentStatusOptions, setCurrentStatusOptions] = useState();
    const [dateCreated, setDateCreated] = useState(date);
    const [outstandingBalance, setOutstandingBalance] = useState();
    const [errorMsg, setErrorMsg] = useState();
    const [successMsg, setSuccessMsg] = useState();
    const [resetUserForm, setResetUserForm] = useState(false);
    const history = useHistory();
    const location = useLocation();

    const {
        reset,
        formState: { errors }
    } = useForm();

    const handleUserSelection = async (e) => {
        setSelectedUser(e);
    };

    const handleReturnOperation = async (e) => {
        setIsEditable(true);
        setSuccessMsg("");
        setButtonText("Save")
    };




    useEffect(() => {
        const getAccountDetails = async () => {
            setSuccessMsg("");
            const searchVal = location?.search?.split("=");
            setButtonText("Save");
            let rtaFromLoc = (location?.search?.split("=")?.[1].split("&")?.[0]).replace(/[^\w @]/g, '');
            let paramAccountIDLoc = (location?.search?.split("=")?.[2].split("&")?.[0]).replace(/[^\w @]/g, '');
            setAccountBankNumber(rtaFromLoc.substring(0 ,3));
            setAccountTransitNumber(rtaFromLoc.substring(3 ,8));
            setAccountNumber(rtaFromLoc.substring(8 ,rtaFromLoc.length))
            setRtaNumber(rtaFromLoc);
            setParamAccountID(paramAccountIDLoc);
            ConsoleHelper(rtaFromLoc,"<----rta   acountId---->",paramAccountIDLoc)
            ConsoleHelper(" GET USERS BY LIST WITH rtanumber: ",rtaNumber)
            const getAccountPropertiesDetails = await axios.get(`${validateAccountManagerExistsApi}?paramRTA=${(location?.search?.split("=")?.[1].split("&")?.[0]).replace(/[^\w @]/g, '')}&paramUserID=${loggedUserStorage}`);
            ConsoleHelper(" is valid account manager  data ",getAccountPropertiesDetails?.data?.response[0]);

            if(getAccountPropertiesDetails?.data?.response.length >0 ){
                setButtonText("Edit");
                setIsEditable(false);
                let accountTypeLbl = getAccountPropertiesDetails?.data?.response[0]?.accountType === "SAV"? "Savings":"Checking"
                setAccountType({
                    label: accountTypeLbl,
                    value: getAccountPropertiesDetails?.data?.response[0]?.accountType,
                });
                setConsolidationType([
                    { label: getAccountPropertiesDetails?.data?.response[0]?.consolidationTypeDesc, value: getAccountPropertiesDetails?.data?.response[0]?.consolidationType },
                ]);
                setCountry({
                    label: getAccountPropertiesDetails?.data?.response[0]?.branchCountry,
                    value: getAccountPropertiesDetails?.data?.response[0]?.branchCountry,
                });
                setSelectedUser({
                    label: getAccountPropertiesDetails?.data?.response[0]?.userIDCreated,
                    value: getAccountPropertiesDetails?.data?.response[0]?.userIDCreated,
                });
                setApprovalFlag(getAccountPropertiesDetails?.data?.response[0]?.requireApproval);//

                let currentStatusLbl = getAccountPropertiesDetails?.data?.response[0]?.status === "AC"? "Active":
                    (getAccountPropertiesDetails?.data?.response[0]?.status === "CD"?"Closed":
                        (getAccountPropertiesDetails?.data?.response[0]?.status === "PK"?"Deleted":""));
                setCurrentStatus({
                    label: currentStatusLbl,
                    value: getAccountPropertiesDetails?.data?.response[0]?.status,
                });//
                setCreatedBy(getAccountPropertiesDetails?.data?.response[0]?.userIDCreated);//
                setDateCreated(DateFormatterWithAMPM(getAccountPropertiesDetails?.data?.response[0]?.dateTimeCreated));//

                setOutstandingBalance();
            }


        };

        const getUsers = async () => {
            var feed = {userId: loggedUserStorage, label: loggedUserStorage, value: loggedUserStorage};
            const result = await axios.get(`${getAccountUserListApi}?paramUserID=${loggedUserStorage}`);
            result?.data.unshift(feed);
            setUserOptions(result?.data);
        }
        setConsolidationOptions([
            { label: "No Consolidation", value: "0" },
            { label: "Consolidate Across Funds Type", value: "1" },
            { label: "Consolidate Across Terminals", value: "2" },
            { label: "Full Consolidation", value: "3" },
        ]);

        setCurrentStatusOptions([
            { label: "Active", value: "AC" },
            { label: "Closed", value: "CD" },
            { label: "Deleted", value: "PK" },
        ]);

        setAccountTypeData([
            { value: "CHK", label: "Checking" },
            { value: "SAV", label: "Savings" }
        ]);
        setSelectedUser({
            label: loggedUserStorage,
            value: loggedUserStorage,
        });

        setCountryData([
            { label: "Select Country", value: "CAN" },
            { label: "Canada", value: "CAN" },
            { label: "United States", value: "USA" },
            { label: "Mexico", value: "MEX" },
            { label: "India", value: "IND" },
            { label: "United Kingdom", value: "UK" },
            { label: "Europe ", value: "EUR" },
        ]);

        ConsoleHelper(" ---------Prop location search ",location)
        if( (typeof location?.search?.split("=")?.[1] !== "undefined")){
            getAccountDetails();
        }
        getUsers();
        return () => {
            setData([]);
            setVisibleToUserSelectData([]);
            setAccountOwnerelectData([]);
           // setUserOptions([]);

        };
    }, [location]);


    useEffect(() => {
        setIsEditable(true)
        const getLocationandTerminals = async () => {
            const selectedUserByDefault = (typeof selectedUser?.userId == "undefined") ? loggedUserStorage : selectedUser?.userId;

        };

        /*const getUserDetailsAfterNavigation = async () => {

            const getPropDetails = await axios.get(`${validateAccountManagerExistsApi}?paramRTA=${rtaNumber}&paramUserID=${loggedUserStorage}`);
            ConsoleHelper(" Properties details ",getPropDetails?.data?.response[0]);

            if(getPropDetails?.data?.response.length >0 ){
                setButtonText("Edit");
                setIsEditable(false);

            }

        };

        getUserDetailsAfterNavigation();*/
        getLocationandTerminals();
        return () => {
            setVisibleToUserSelectData([]);
        };
    }, [resetUserForm]);

    const handleSaveReport = async () => {

        try {
            setRtaNumber(accountBankNumber+accountTransitNumber+accountNumber);
            ConsoleHelper(accountBankNumber,accountTransitNumber,accountNumber,rtaNumber,"CALLING SAVE FUNCTION");
            const result = await axios.get(`${validateAccountManagerExistsApi}?paramRTA=${accountBankNumber+accountTransitNumber+accountNumber}&paramUserID=${loggedUserStorage}`);
            ConsoleHelper(" is valid account manager  data ",(result?.data?.response.length >0 && location?.search?.split("=").length<2));
            if(result?.data?.response.length >0 && location?.search?.split("=").length<2){
                setErrorMsg("The RTA already exist");
                setSuccessMsg("");
                setButtonText("Save");
                setIsEditable(true);
                return false;
            }else{
                //now account has been checked is created or not , now need to check if rta is associated with account or not
                const paramSettlementACHFileID = '1';
                const paramSettlementScheduleType = '0';
                const paramSettlementScheduleDay = '0';
                const paramSettlementThresholdAmount = '0';
                const paramSurchargeACHFileID = '1';
                const paramSurchargeScheduleType = '0';
                const paramSurchargeScheduleDay = '0';
                const paramSurchargeThresholdAmount = '0';
                const paramInterchangeACHFileID = '1';
                const paramInterchangeScheduleType = '0';
                const paramInterchangeScheduleDay = '0';
                const paramInterchangeThresholdAmount = '0';
                const paramBankName = '';
                const paramBranchAddress = '';
                const paramBranchCity = '';
                const paramBranchRegion = '';
                const paramBranchPostalCode = '';
                const paramBranchPhone = '';
                const paramHolderName = '';
                const paramHolderAddress = '';
                const paramHolderCity = '';
                const paramHolderRegion = '';
                const paramHolderPostalCode = '';
                const paramHolderPhone = '';
                const paramComment = '';
                const paramResponse= '-1';
                const paramSettlementSchedulePayoutDay = '1';
                const paramSurchargeSchedulePayoutDay = '1';
                const paramInterchangeSchedulePayoutDay = '1';
                //const isRTAResponseResult = await axios.get(`${isRTAExistsApi}?paramRTA=${rtaNumber}`);
                //ConsoleHelper(" is RTA Valid",isRTAResponseResult?.data?.response);


                ConsoleHelper(" rtaNumber ",rtaNumber,accountType,consolidationType)
                ConsoleHelper(" currentStatus ",currentStatus?.value)
                ConsoleHelper(" approvalFlag ",approvalFlag)
                ConsoleHelper("country",country)

                const headers= {"Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods":"*",
                    "Access-Control-Allow-Headers":"*",
                };
                //Check if edit then call edit process and pass edit process wiht passsing Account ID
                ConsoleHelper(location?.search?.split("=").length>1)
                if(location?.search?.split("=").length>1) {
                    ConsoleHelper(" Editing Account details for ::",paramAccountID)
                    const editAccountManagerResult = await axios.get(`${editAccountManagerApi}?paramAccountID=${paramAccountID}&paramHolderName=${paramHolderName}&paramRTA=${rtaNumber}&paramAccountType=${accountType?.value}&paramResponse=${paramResponse}&paramConsolidationType=${consolidationType?.value}&paramUserIDOwner=${loggedUserStorage}&paramRequireApproval=${approvalFlag}&paramStatus=${currentStatus?.value}&paramSettlementACHFileID=${paramSettlementACHFileID}&paramSettlementScheduleType=${paramSettlementScheduleType}&paramSettlementScheduleDay=${paramSettlementScheduleDay}&paramSettlementThresholdAmount=${paramSettlementThresholdAmount}&paramSurchargeACHFileID=${paramSurchargeACHFileID}&paramSurchargeScheduleType=${paramSurchargeScheduleType}&paramSurchargeScheduleDay=${paramSurchargeScheduleDay}&paramSurchargeThresholdAmount=${paramSurchargeThresholdAmount}&paramInterchangeACHFileID=${paramInterchangeACHFileID}&paramInterchangeScheduleType=${paramInterchangeScheduleType}&paramInterchangeScheduleDay=${paramInterchangeScheduleDay}&paramInterchangeThresholdAmount=${paramInterchangeThresholdAmount}&paramBankName=${paramBankName}&paramBranchAddress=${paramBranchAddress}&paramBranchCity=${paramBranchCity}&paramBranchRegion=${paramBranchRegion}&paramBranchCountry=${country?.value}&paramBranchPostalCode=${paramBranchPostalCode}&paramBranchPhone=${paramBranchPhone}&paramHolderAddress=${paramHolderAddress}&paramHolderCity=${paramHolderCity}&paramHolderRegion=${paramHolderRegion}&paramHolderCountry=${country?.value}&paramHolderPostalCode=${paramHolderPostalCode}&paramHolderPhone=${paramHolderPhone}&paramComment=${paramComment}&paramCurrentUserID=${loggedUserStorage}&paramSettlementSchedulePayoutDay=${paramSettlementSchedulePayoutDay}&paramSurchargeSchedulePayoutDay=${paramSurchargeSchedulePayoutDay}&paramInterchangeSchedulePayoutDay=${paramInterchangeSchedulePayoutDay}`);
                    ConsoleHelper(" save edit Result data ", editAccountManagerResult?.data?.response);
                    setSuccessMsg("Data Saved SuccessFully");
                    setButtonText("Edit");
                    setIsEditable(false);
                }else{
                    const saveAccountManagerResult = await axios.get(`${saveAccountManagerApi}?paramHolderName=${paramHolderName}&paramRTA=${accountBankNumber+accountTransitNumber+accountNumber}&paramAccountType=${accountType?.value}&paramConsolidationType=${consolidationType?.value}&paramUserIDOwner=${loggedUserStorage}&paramRequireApproval=${approvalFlag}&paramStatus=${currentStatus?.value}&paramSettlementACHFileID=${paramSettlementACHFileID}&paramSettlementScheduleType=${paramSettlementScheduleType}&paramSettlementScheduleDay=${paramSettlementScheduleDay}&paramSettlementThresholdAmount=${paramSettlementThresholdAmount}&paramSurchargeACHFileID=${paramSurchargeACHFileID}&paramSurchargeScheduleType=${paramSurchargeScheduleType}&paramSurchargeScheduleDay=${paramSurchargeScheduleDay}&paramSurchargeThresholdAmount=${paramSurchargeThresholdAmount}&paramInterchangeACHFileID=${paramInterchangeACHFileID}&paramInterchangeScheduleType=${paramInterchangeScheduleType}&paramInterchangeScheduleDay=${paramInterchangeScheduleDay}&paramInterchangeThresholdAmount=${paramInterchangeThresholdAmount}&paramBankName=${paramBankName}&paramBranchAddress=${paramBranchAddress}&paramBranchCity=${paramBranchCity}&paramBranchRegion=${paramBranchRegion}&paramBranchCountry=${country?.value}&paramBranchPostalCode=${paramBranchPostalCode}&paramBranchPhone=${paramBranchPhone}&paramHolderAddress=${paramHolderAddress}&paramHolderCity=${paramHolderCity}&paramHolderRegion=${paramHolderRegion}&paramHolderCountry=${country?.value}&paramHolderPostalCode=${paramHolderPostalCode}&paramHolderPhone=${paramHolderPhone}&paramComment=${paramComment}&paramCurrentUserID=${loggedUserStorage}&paramSettlementSchedulePayoutDay=${paramSettlementSchedulePayoutDay}&paramSurchargeSchedulePayoutDay=${paramSurchargeSchedulePayoutDay}&paramInterchangeSchedulePayoutDay=${paramInterchangeSchedulePayoutDay}`,
                        {headers},
                        { crossdomain: true });

                    const result = await axios.get(`${validateAccountManagerExistsApi}?paramRTA=${accountBankNumber+accountTransitNumber+accountNumber}&paramUserID=${loggedUserStorage}`);
                    ConsoleHelper(" save Result data ",result?.data?.response[0]);
                    setParamAccountID(result?.data?.response[0].accountID)
                    setErrorMsg("");
                    setSuccessMsg("Data Saved SuccessFully");
                    setButtonText("Save");
                    setIsEditable(false);
                    //const {accountList, setAccountList}  = useContext(terminalListContext);
                    history.push({
                        pathname: "/accountManager/holder",
                        search: `rta=${accountBankNumber+accountTransitNumber+accountNumber}&AccountID=${result?.data?.response[0].accountID}`,
                    });
                    ConsoleHelper(" AccountID after retrieval ",paramAccountID);
                }



            }
            setData(result?.data?.response);
        } catch (error) {}
    };
    return (
        <div>
            <div className="row">
                <div className="col-md-12">
                    <h5 className="tbsub-title mt-3 mb-3">Account Information</h5>
                    {errorMsg ? (
                        <div className="form-group row">
                            <label className="control-label col-md-4" style={{color:"red",fontWeight:"bold",textAlign:"end"}}>The RTA already exist	</label>
                        </div>) : ((successMsg&&!isEditable) ? (
                        <label className="control-label col-md-4" style={{color:"green",fontWeight:"bold",textAlign:"end"}}>Data Saved SuccessFully.</label>
                    ):(<span>&nbsp;{successMsg}</span>))

                    }
                    <form>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between">

                            <label>RTA/Account No:{!isEditable}</label>
                            {!isEditable ? (
                                /*<input
                                    type="text"
                                    className="form-control form-control-sm col-md-9"
                                    style={{ marginLeft: '115px'}}
                                    readOnly={!isEditable}
                                    defaultValue={rtaNumber}
                                    onChange={(e) =>
                                        setRtaNumber(
                                            (e.target.value)
                                        )
                                    }
                                />*/

                                <>
                                <div className="parent">
                                    <div className="block1">
                                        <input
                                            type="text"
                                            maxlength="3"   pattern="\d{3}"
                                            className="form-control form-control-sm"
                                            placeholder={"Bank"}
                                            readOnly={true}
                                            defaultValue={accountBankNumber}
                                            onChange={(e) =>
                                                setAccountBankNumber(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                    <div class="block2">
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            maxlength="5"   pattern="\d{5}"
                                            placeholder={"Routing"}
                                            readOnly={true}
                                            defaultValue={accountTransitNumber}
                                            onChange={(e) =>
                                                setAccountTransitNumber(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                    <div class="block3">
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            maxlength="17"   pattern="\d{17}"
                                            placeholder={"Account"}
                                            readOnly={true}
                                            defaultValue={accountNumber}
                                            onChange={(e) =>
                                                setAccountNumber(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                                </>
                            ) : (
                                <>

                                <div className="parent">
                                    <div class="block1">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        maxlength="3"   pattern="\d{3}"
                                        placeholder={"Bank"}
                                        readOnly={false}
                                        defaultValue={accountBankNumber}
                                        onChange={(e) =>
                                            setAccountBankNumber(
                                                (e.target.value)
                                            )
                                        }
                                    />
                                    </div>
                                <div class="block2">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        maxlength="5"   pattern="\d{5}"
                                        placeholder={"Routing"}
                                        readOnly={false}
                                        defaultValue={accountTransitNumber}
                                        onChange={(e) =>
                                            setAccountTransitNumber(
                                                (e.target.value)
                                            )
                                        }
                                    />
                                </div>
                                <div class="block3">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        maxlength="17"   pattern="\d{17}"
                                        placeholder={"Account"}
                                        readOnly={false}
                                        defaultValue={accountNumber}
                                        onChange={(e) =>
                                            setAccountNumber(
                                                (e.target.value)
                                            )
                                        }
                                    />
                                    </div>
                                </div>
                                </>
                            )}
                    </div>
                </div>
            </div>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between ">
                                    <label>Account Type:</label>
                                    <div>
                                        {/*<select readOnly={!isEditable} name="paramCountry" onChange={(e) =>setAccountType((e.target.value))}
                                                className="form-control form-control-sm col-md-12" style={{width: "15.5vw"}}>
                                            <option value="CHK">Checking</option>
                                            <option value="SAV">Saving</option>
                                        </select>*/}
                                        <Select
                                            options={accountTypeData}
                                            isDisabled={!isEditable}
                                            filterOption={createFilter({ ignoreAccents: false })}
                                            captureMenuScroll={false}
                                            classNamePrefix="custom-select"
                                            components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                            value={accountType}
                                            onChange={(e) =>setAccountType((e))}
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    flex: 1,
                                                    width: "15.5vw",
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between">
                                    <label>Country:</label>
                                    <div>
                                        <Select
                                            options={countryData}
                                            isDisabled={!isEditable}
                                            filterOption={createFilter({ ignoreAccents: false })}
                                            captureMenuScroll={false}
                                            classNamePrefix="custom-select"
                                            components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                            value={country}
                                            onChange={(e) =>setCountry((e))}
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    flex: 1,
                                                    width: "15.5vw",
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
            {/*  */}
            <div className="row mt-2">
                <div className="col col-md-5">
                    <div className="d-flex justify-content-between">
                        <label>Consolidation Type:</label>
                        <div>
                            <Select
                                options={consolidationOptions}
                                isDisabled={!isEditable}
                                filterOption={createFilter({ ignoreAccents: false })}
                                captureMenuScroll={false}
                                classNamePrefix="custom-select"
                                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                value={consolidationType}
                                onChange={(e) =>setConsolidationType((e))}
                                styles={{
                                    container: (provided) => ({
                                        ...provided,
                                        flex: 1,
                                        width: "15.5vw",
                                    }),
                                }}
                            />
                        </div>
                    </div>

                </div>
            </div>
             <div className="row mt-2">
                <div className="col col-md-5">
                    <div className="d-flex justify-content-between ">
                        <label>Owner:</label>
                        <div>
                            <Select isDisabled={!isEditable}
                                options={userOptions}
                                value={selectedUser}
                                onChange={handleUserSelection}
                                filterOption={createFilter({ ignoreAccents: false })}
                                captureMenuScroll={false}
                                classNamePrefix="custom-select"
                                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                styles={{
                                    container: (provided) => ({
                                        ...provided,
                                        flex: 1,
                                        width: "15.5vw",
                                    }),
                                }}
                            />
                        </div>
                    </div>
                </div>
             </div>
             <div className="row mt-2">
                <div className="col col-md-5">
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Approval Flags:</label>
                        <div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                style={{width: "15.5vw"}}
                                readOnly={true}
                                value={approvalFlag}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col col-md-5">
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Current Status:</label>
                        <div>
                            {/*<select readOnly={!isEditable} name="paramCountry" onChange={(e) =>setCurrentStatus((e.target.value))}
                                    className="form-control form-control-sm" style={{width: "15.5vw"}}>
                                <option selected="selected" value="AC">Active</option>
                                <option value="CD">Closed</option>
                                <option value="PX">Deleted</option>
                            </select>*/}
                            <Select isDisabled={!isEditable}
                                    options={currentStatusOptions}
                                    value={currentStatus}
                                    onChange={(e) =>setCurrentStatus((e))}
                                    filterOption={createFilter({ ignoreAccents: false })}
                                    captureMenuScroll={false}
                                    classNamePrefix="custom-select"
                                    components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                    styles={{
                                        container: (provided) => ({
                                            ...provided,
                                            flex: 1,
                                            width: "15.5vw",
                                        }),
                                    }}
                            />
                        </div>
                    </div>
                </div>
            </div>
             <div className="row mt-2">
                <div className="col col-md-5">
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Created By:</label>
                        <div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                style={{width: "15.5vw"}}
                                readOnly={true}
                                value={createdBy}
                            />
                        </div>
                    </div>
                </div>
            </div>
                        <div className="row mt-4">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between">
                                    <label>Date Created:</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            style={{width: "15.5vw"}}
                                            readOnly={true}
                                            value={dateCreated}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between">
                                    <label>Outstanding Balance:</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            style={{width: "15.5vw"}}
                                            value={0.0}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
            <div className="row d-flex justify-content-center mt-1 align-items-center">
                {!isEditable ? (
                    <div  className="d-flex justify-content-center">
              <span
                  className="input-group-text"
                  role="button"
                  onClick={() => handleReturnOperation()}>Edit</span>
                    </div>
                ) : (
                    <span
                        className="input-group-text"
                        role="button"
                        onClick={() => handleSaveReport()}>Save</span>
                )}
            </div>
                        {/*<div className="col-md-3">
                            <button className="btn btn-block btn-primary w-md"
                                    type="button"
                                    onClick={() => reset()}
                                    value="Reset"
                            >Reset</button>
                        </div>*/}
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AccountManagerProperties;
